<template>
  <div ref="mask" class="dialog-mask" :class="[show ? 'show' : '', type + '-mask' ]">
    <div ref="dialog" class="dialog">
      <i class="dialog-close" @click="close"></i>
      <div class="dialog-body" :class="type + '-dialog'">
        <h3 class="title" v-if="title">{{title}}</h3>
        <slot name="dialog-content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import VueAnime from '@/utils/animate.js'
const anime = new VueAnime()
export default {
  props: {
    type: String,
    title: String,
    show: Boolean
  },
  watch: {
    show (val) {
      if (val) {
        this.showDialog()
      } else {
        this.$refs.mask.style.opacity = 0
      }
    }
  },
  methods: {
    showDialog () {
      switch (this.type) {
        case 'reward':
        case 'confirm':
          anime.maskIn(this.$refs.mask, () => {
            anime.heartBeatIn(this.$refs.dialog)
          })
        break
        default:
          anime.maskIn(this.$refs.mask, () => {
            anime.topIn(this.$refs.dialog)
          })
        break
      }
    },
    close () {
      switch (this.type) {
        case 'reward':
        case 'confirm':
          anime.heartBeatOut(this.$refs.dialog, () => {
            anime.maskOut(this.$refs.mask, () => {
              this.hideDialog()
            }, 200, 200)
          })
          break
        default:
          anime.topOut(this.$refs.dialog, () => {
            anime.maskOut(this.$refs.mask, () => {
              this.hideDialog()
            })
          })
        break
      }
    },
    hideDialog () {
      switch (this.type) {
        case 'rule':
          this.$bus.rule.show = false
        break
        case 'history':
          this.$bus.history.show = false
        break
        case 'reward':
          this.$bus.rewardDialog.show = false
        break
        case 'confirm':
          this.$bus.confirmDialog.show = false
        break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100vw;
  height: 100vh;
  opacity: 0;
  background: rgba(0, 0, 0, .82);
  display: none;
}
.dialog-mask.show {
  display: block;
}
.dialog {
  position: absolute;
  left: 50%;
  top: 50%;
  @include px2res(width, 824);
  @include px2res(height, 475);
  @include px2res(margin, -238, 0, 0, -412);
  .dialog-close {
    position: absolute;
    z-index: 9;
    @include px2res(top, 50);
    @include px2res(left, 40);
    @include px2res(width, 50);
    @include px2res(height, 50);
  }
  .dialog-body {
    @include flexrc;
    flex-direction: column;
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    height: 100%;
    .title {
      width: 100%;
      text-align: center;
      font-weight: 500;
      color: #FFDBA7;
      font-style: italic;
      position: relative;
      z-index: 1;
      @include px2res(font-size, 40);
      text-transform: uppercase;
    }
  }
  // reward dialog
  .reward-dialog {
    @include px2res(padding, 50, 30, 30);
    justify-content: space-between;
  }
  .history-dialog {
    @include px2res(padding, 50, 10);
  }
  .rule-dialog {
    @include px2res(padding, 50, 30);
  }
  .rule-dialog, .history-dialog {
    align-items: flex-start;
    justify-content: flex-start;
  }
  .confirm-dialog {
    width: 100%;
    height: 100%;
    @include px2res(padding, 60, 20);
    justify-content: space-around;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Dialog.vue